'use client';

import { useAppBridge } from '@shopify/app-bridge-react';
import { useCallback } from 'react';

export const useToast = () => {
  const shopify = useAppBridge();

  const notify = useCallback(
    (message: string, duration = 5000) =>
      shopify.toast.show(message, {
        duration,
      }),
    [shopify]
  );

  /**
   * @deprecated Shopify BFS rules are against error in toasts
   */
  const notifyError = useCallback(
    (message: string, duration = 5000) =>
      shopify.toast.show(message, {
        duration,
        isError: true,
      }),
    [shopify]
  );

  return {
    notify,
    notifyError,
  };
};
